import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import _imports_0 from '../../../assets/icon/link.svg';
var _hoisted_1 = {
  key: 2,
  class: "custom_function"
};
var _hoisted_2 = {
  style: {
    "height": "500px",
    "overflow": "auto"
  }
};
import { ref, computed, onUnmounted, reactive } from '../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import EmojiPicker from './emoji-picker/index.vue';
import ImageUpload from './image-upload/index.vue';
// import FileUpload from './file-upload/index.vue'
// import VideoUpload from './video-upload/index.vue'
// import Evaluate from './evaluate/index.vue'
import Words from './words/index.vue';
import ToolbarItemContainer from './toolbar-item-container/index.vue';
import UserSelector from './user-selector/index.vue';
import { isPC, isH5, isUniFrameWork } from '../../../utils/env';
import TUIChatConfig from '../config';
import { enableSampleTaskStatus } from '../../../utils/enableSampleTaskStatus';
import LinkCreateDialog from '../../../../views/work_bench/link_todo/add.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['insertEmoji'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var dataOwn = reactive({
      showLinkDialog: false,
      customMessageType: '',
      linkParams: {
        fromGroup: true,
        source: 3,
        customMessageType: '',
        currentConversation: {}
      }
    });
    var emits = __emit;
    var h5Dialog = ref();
    var currentConversation = ref();
    var isGroup = ref(false);
    var selectorShowType = ref('');
    var userSelectorRef = ref();
    var currentUserSelectorExtension = ref();
    var currentExtensionList = ref([]);
    var getExtensionList = conversationID => {
      if (!conversationID) {
        return currentExtensionList.value = extensionList;
      }
      var chatType = TUIChatConfig.getChatType();
      var options = {
        chatType
      };
      // 向下兼容，callkit 没有chatType 判断时，使用 filterVoice、filterVideo 过滤
      if (chatType === 'customerService') {
        options.filterVoice = true;
        options.filterVideo = true;
        enableSampleTaskStatus('customerService');
      }
      currentExtensionList.value = [...TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID, options)];
    };
    var onCurrentConversationUpdate = conversation => {
      var _currentConversation$, _currentConversation$2;
      if (conversation !== null && conversation !== void 0 && conversation.conversationID && ((_currentConversation$ = currentConversation.value) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.conversationID) !== (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID)) {
        getExtensionList(conversation === null || conversation === void 0 ? void 0 : conversation.conversationID);
      }
      currentConversation.value = conversation;
      dataOwn.linkParams.currentConversation = currentConversation.value;
      if ((currentConversation === null || currentConversation === void 0 || (_currentConversation$2 = currentConversation.value) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.type) === TUIChatEngine.TYPES.CONV_GROUP) {
        isGroup.value = true;
      } else {
        isGroup.value = false;
      }
    };
    TUIStore.watch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdate
      });
    });
    // extensions
    var extensionList = [...TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID)];
    // 按展示位置分类 extensionList （注意：仅 web 端 区分展示位置在 从 start 开始和 从 end 开始，在移动端不生效）
    var extensionListShowInStart = computed(() => isPC ? currentExtensionList.value.filter(extension => {
      var _extension$data;
      return (extension === null || extension === void 0 || (_extension$data = extension.data) === null || _extension$data === void 0 ? void 0 : _extension$data.name) !== 'search';
    }) : currentExtensionList.value);
    var extensionListShowInEnd = computed(() => {
      if (isPC) {
        var searchExtension = currentExtensionList.value.find(extension => {
          var _extension$data2;
          return (extension === null || extension === void 0 || (_extension$data2 = extension.data) === null || _extension$data2 === void 0 ? void 0 : _extension$data2.name) === 'search';
        });
        return searchExtension ? [searchExtension] : [];
      }
      return [];
    });
    // handle extensions onclick
    var onExtensionClick = extension => {
      var _extension$data3, _extension$listener, _currentConversation$3;
      switch (extension === null || extension === void 0 || (_extension$data3 = extension.data) === null || _extension$data3 === void 0 ? void 0 : _extension$data3.name) {
        case 'voiceCall':
          onCallExtensionClicked(extension, 1);
          break;
        case 'videoCall':
          onCallExtensionClicked(extension, 2);
          break;
        default:
          extension === null || extension === void 0 || (_extension$listener = extension.listener) === null || _extension$listener === void 0 || _extension$listener.onClicked((_currentConversation$3 = currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3._conversation);
          break;
      }
    };
    var onCallExtensionClicked = (extension, callType) => {
      var _extension$data4, _currentConversation$4;
      selectorShowType.value = extension === null || extension === void 0 || (_extension$data4 = extension.data) === null || _extension$data4 === void 0 ? void 0 : _extension$data4.name;
      if ((currentConversation === null || currentConversation === void 0 || (_currentConversation$4 = currentConversation.value) === null || _currentConversation$4 === void 0 ? void 0 : _currentConversation$4.type) === TUIChatEngine.TYPES.CONV_C2C) {
        var _extension$listener2, _extension$listener2$, _currentConversation$5;
        (_extension$listener2 = extension.listener) === null || _extension$listener2 === void 0 || (_extension$listener2$ = _extension$listener2.onClicked) === null || _extension$listener2$ === void 0 || _extension$listener2$.call(_extension$listener2, {
          userIDList: [currentConversation === null || currentConversation === void 0 || (_currentConversation$5 = currentConversation.value) === null || _currentConversation$5 === void 0 || (_currentConversation$5 = _currentConversation$5.conversationID) === null || _currentConversation$5 === void 0 ? void 0 : _currentConversation$5.slice(3)],
          type: callType
        });
      } else if (isGroup.value) {
        var _userSelectorRef$valu;
        currentUserSelectorExtension.value = extension;
        (userSelectorRef === null || userSelectorRef === void 0 || (_userSelectorRef$valu = userSelectorRef.value) === null || _userSelectorRef$valu === void 0 ? void 0 : _userSelectorRef$valu.toggleShow) && userSelectorRef.value.toggleShow(true);
      }
    };
    var genExtensionIcon = extension => {
      return extension === null || extension === void 0 ? void 0 : extension.icon;
    };
    var genExtensionText = extension => {
      return extension === null || extension === void 0 ? void 0 : extension.text;
    };
    var onUserSelectorSubmit = selectedInfo => {
      var _currentUserSelectorE, _currentUserSelectorE2;
      (_currentUserSelectorE = currentUserSelectorExtension.value) === null || _currentUserSelectorE === void 0 || (_currentUserSelectorE = _currentUserSelectorE.listener) === null || _currentUserSelectorE === void 0 || (_currentUserSelectorE2 = _currentUserSelectorE.onClicked) === null || _currentUserSelectorE2 === void 0 || _currentUserSelectorE2.call(_currentUserSelectorE, selectedInfo);
      currentUserSelectorExtension.value = undefined;
    };
    var onUserSelectorCancel = () => {
      currentUserSelectorExtension.value = undefined;
    };
    var insertEmoji = emojiObj => {
      emits('insertEmoji', emojiObj);
    };
    var dialogShowInH5 = dialogDom => {
      var _h5Dialog$value, _h5Dialog$value2;
      if (!isH5) {
        return;
      }
      (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value = h5Dialog.value) === null || _h5Dialog$value === void 0 ? void 0 : _h5Dialog$value.appendChild) && (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value2 = h5Dialog.value) === null || _h5Dialog$value2 === void 0 ? void 0 : _h5Dialog$value2.appendChild(dialogDom));
    };
    var dialogCloseInH5 = dialogDom => {
      var _h5Dialog$value3, _h5Dialog$value4;
      if (!isH5) {
        return;
      }
      (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value3 = h5Dialog.value) === null || _h5Dialog$value3 === void 0 ? void 0 : _h5Dialog$value3.removeChild) && (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value4 = h5Dialog.value) === null || _h5Dialog$value4 === void 0 ? void 0 : _h5Dialog$value4.removeChild(dialogDom));
    };
    // 发送自定义消息
    var handleSendCustomMessage = type => {
      dataOwn.customMessageType = type;
      dataOwn.linkParams.customMessageType = type;
      console.log("type-->", type);
      if (type == 'link') {
        var groupType = currentConversation.value.groupProfile.avatar == 'https://www.bio-cloud.com.cn:8022/icon/custom_group.png' ? 'custom' : 'normal';
        dataOwn.linkParams.source = groupType == 'custom' ? 3 : 6;
      } else if (type == 'demo') {
        dataOwn.linkParams.source = 5;
      } else if (type == 'material_customization') {
        dataOwn.linkParams.source = 7;
      }
      console.log("dataOwn.linkParams-->", dataOwn.linkParams);
      dataOwn.showLinkDialog = !dataOwn.showLinkDialog;
    };
    return (_ctx, _cache) => {
      var _unref2;
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['message-input-toolbar', !_unref(isPC) && 'message-input-toolbar-h5', _unref(isUniFrameWork) && 'message-input-toolbar-uni'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['message-input-toolbar-list', !_unref(isPC) && 'message-input-toolbar-h5-list', _unref(isUniFrameWork) && 'message-input-toolbar-uni-list'])
      }, [!_unref(isUniFrameWork) ? (_openBlock(), _createBlock(EmojiPicker, {
        key: 0,
        onInsertEmoji: insertEmoji,
        onDialogShowInH5: dialogShowInH5,
        onDialogCloseInH5: dialogCloseInH5
      })) : _createCommentVNode("", true), _unref(isUniFrameWork) ? (_openBlock(), _createBlock(ImageUpload, {
        key: 1,
        imageSourceType: "camera"
      })) : _createCommentVNode("", true), _createVNode(ImageUpload, {
        imageSourceType: "album"
      }), _createVNode(Words), ((_unref2 = _unref(currentConversation)) === null || _unref2 === void 0 ? void 0 : _unref2.type) == 'GROUP' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(currentConversation).groupProfile.avatar == 'https://www.bio-cloud.com.cn:8022/icon/custom_group.png' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "custom_function_img",
        onClick: _cache[0] || (_cache[0] = $event => handleSendCustomMessage('demo'))
      }, _cache[4] || (_cache[4] = [_createElementVNode("img", {
        src: "https://www.bio-cloud.com.cn:8022/icon/fanchang.svg",
        alt: "Demo返厂"
      }, null, -1)]))) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "custom_function_img",
        onClick: _cache[1] || (_cache[1] = $event => handleSendCustomMessage('link'))
      }, _cache[5] || (_cache[5] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "Link"
      }, null, -1)]))])) : _createCommentVNode("", true), _unref(extensionListShowInStart)[0] ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 3
      }, _renderList(_unref(extensionListShowInStart), extension => {
        return _openBlock(), _createBlock(ToolbarItemContainer, {
          key: extension.id,
          iconFile: genExtensionIcon(extension),
          title: genExtensionText(extension),
          iconWidth: _unref(isUniFrameWork) ? '25px' : '20px',
          iconHeight: _unref(isUniFrameWork) ? '25px' : '20px',
          needDialog: false,
          onOnIconClick: $event => onExtensionClick(extension)
        }, null, 8, ["iconFile", "title", "iconWidth", "iconHeight", "onOnIconClick"]);
      }), 128)) : _createCommentVNode("", true)], 2), _createVNode(UserSelector, {
        ref_key: "userSelectorRef",
        ref: userSelectorRef,
        type: _unref(selectorShowType),
        currentConversation: _unref(currentConversation),
        isGroup: _unref(isGroup),
        onSubmit: onUserSelectorSubmit,
        onCancel: onUserSelectorCancel
      }, null, 8, ["type", "currentConversation", "isGroup"]), _unref(isH5) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "h5Dialog",
        ref: h5Dialog,
        class: _normalizeClass(['message-input-toolbar-h5-dialog'])
      }, null, 512)) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(dataOwn).customMessageType == 'demo' ? 'Demo返厂' : _unref(dataOwn).customMessageType == 'material_customization' ? '定制品待办' : '待办',
        modelValue: _unref(dataOwn).showLinkDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(dataOwn).showLinkDialog = $event),
        "show-close": true,
        width: "600px",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(LinkCreateDialog, {
          fromGroup: true,
          linkParams: _unref(dataOwn).linkParams,
          currentConversation: _unref(currentConversation),
          customMessageType: _unref(dataOwn).customMessageType,
          onHandle_close_linkDialog: _cache[2] || (_cache[2] = $event => _unref(dataOwn).showLinkDialog = false)
        }, null, 8, ["linkParams", "currentConversation", "customMessageType"])])]),
        _: 1
      }, 8, ["title", "modelValue"])], 2);
    };
  }
});